import React from "react";
import LabeledCheckBox from "./LabeledCheckBox";
import styled from "styled-components";

const FormSectionContainer = styled.div.attrs({
  className: "FormSection",
})`
  margin: 0 0 1em 0;
`;

const DialogContainer = styled.div`
  max-height: calc(100vh - 70px);
  overflow-y: auto;
`;

const Title = styled.h1`
  font-size: 1.4em;
  font-weight: bold;
  margin-bottom: 0.5em;
`;

const TextInput = styled.input`
  width: 100%;
  padding: 0.5em 1em;
  border: 1px solid lightgray;
  border-radius: 8px;
  box-sizing: border-box;
`;

const SubmitButton = styled.button.attrs({
  className: "SubmitButton",
})`
  background-color: ${props => (props.disabled ? "#888888" : "#3479FF")};
  border: none;
  border-radius: 4px;
  color: white;
  padding: 1em 2em;
  text-align: center;
  text-decoration: none;
  display: inline-block;

  :hover {
    background-color: ${props => (props.disabled ? "#888888" : "#6699FF")};
  }
`;

const SwapSpeakersButton = styled.button.attrs({
  className: "SwapSpeakerButton",
})`
  background-color: ${props => (props.disabled ? "#888888" : "#3479FF")};
  border: none;
  border-radius: 4px;
  color: white;
  padding: 1em 1em;
  text-align: center;
  text-decoration: none;
  display: inline-block;

  :hover {
    background-color: ${props => (props.disabled ? "#888888" : "#6699FF")};
  }
`;

class MetadataDialog extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      submitted: false,
    };

    this.onSubmit = this.onSubmit.bind(this);
    this.flag = this.flag.bind(this);
  }

  redirectToQaWorldHomePage() {
    if (window.location.toString().includes("false_negatives")) {
      window.location.replace(
        window.location.origin + "/qa_records/false_negatives"
      );
    } else {
      window.location.replace(window.location.origin + "/calls");
    }
  }

  flag(status){
    let dataHandler = this.props.flagCall;

    if (!this.state.submitted) {
      this.setState({ loading: true }, () => {
        dataHandler(status).then(() => {
          this.setState({ loading: false, submitted: true }, () => {
            this.redirectToQaWorldHomePage();
          });
        });
      });
    }
  }

  onSubmit() {
    let dataHandler = this.props.onSubmit;

    if (!this.state.submitted) {
      this.setState({ loading: true }, () => {
        dataHandler().then(() => {
          this.setState({ loading: false, submitted: true }, () => {
            this.redirectToQaWorldHomePage();
          });
        });
      });
    }
  }

  render() {
    let {
      company,
      callId,
      outcomes,
      tags,
      selectedOutcomes,
      selectedTag,
      onNameChange,
      onOutcomeChange,
      onTagChange,
      callOccurredAt,
      swapSpeakers,
      audioUrl,
      flags,
      flagCall,
    } = this.props;

    return (
      <DialogContainer>
        <FormSectionContainer>
          <Title>Company: {company}</Title>
          <Title>ID: {callId}</Title>
          <Title>Call Occurred On: {callOccurredAt}</Title>
          <div className="py-2">
            <audio controls src={audioUrl}/>
          </div>
          <SwapSpeakersButton onClick={() => swapSpeakers()} disabled={this.state.loading}>Swap Speakers</SwapSpeakersButton>
          {Object.entries(flags).map(
            ([status, text]) => <button className='d-block btn btn-danger my-2' onClick={() => this.flag(status)}>{text}</button>
          )}
        </FormSectionContainer>

        <FormSectionContainer>
          <Title>Did the customer say their name?</Title>
          <TextInput type="text" onChange={onNameChange} />
        </FormSectionContainer>

        <FormSectionContainer>
          <Title>Which best describes this call?</Title>
          {tags.map(tag => (
            <div className="tag-container" key={tag.id}>
              <LabeledCheckBox
                type="radio"
                label={tag.name}
                value={tag.id}
                checked={selectedTag === tag.id}
                onChange={e => onTagChange(tag.id, e)}
              />
            </div>
          ))}
        </FormSectionContainer>

        <FormSectionContainer>
          <Title>
            What were the outcomes of the call? (Only leave blank if no outcomes
            apply)
          </Title>
          {outcomes.map(outcome => (
            <div className="outcome-container" key={outcome.id}>
              <LabeledCheckBox
                id={outcome.id}
                type="checkbox"
                label={outcome.name}
                checked={selectedOutcomes.has(outcome.id)}
                onChange={e => onOutcomeChange(outcome.id, e)}
              />
            </div>
          ))}
        </FormSectionContainer>
        {this.state.loading ? (
          <SubmitButton disabled={true}>Submitting...</SubmitButton>
        ) : (
          <SubmitButton onClick={this.onSubmit}>Submit</SubmitButton>
        )}
      </DialogContainer>
    );
  }
}

export default MetadataDialog;
